import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = 'にいがた県政出前講座 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="にいがた県政出前講座" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2024春号 No.166 目次",
              path: "/no166"
            },
            {
              name: "にいがた県政出前講座"
            }
          ]}
        />
        
        <p>県民のみなさんが開催する集会等に職員が出向き、県が取り組む事業や施策などを分かりやすく説明します。</p>
        
        <img
          src={`${basePath}/no166/img/4-11.png`}
          alt="イラスト"
          css={style.img(300, "15px 0 0 0")}
        />
        
        <p>福祉、環境、産業、教育など生活に密着した分野をはじめ、県が重点的に取り組んでいる施策に関することなど、100種類のテーマを用意！</p>
        
        <p>職場や学校、自治会などのグループでお気軽にお申込みください！</p>
        
        <p css={style.notetTxt}>＊ オンラインでの開催も受け付けます。担当課にご相談ください。<br />
        ＊ 職員の派遣費用や資料代は不要です（集会の開催・運営経費等は、申込者の負担となります）。</p>
        
        
        <p>申込方法は
          <a
            href="https://www.pref.niigata.lg.jp/sec/kouhou/1356891811479.html"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <BackBtn href={"/no166"} />
      </Content>
    </Page>
  )
}
export default Home
